export function formatCropDialogTitle(title: string, cropName: string) {
  return `${title} - ${cropName}`;
}
